module.exports = __webpack_public_path__ + "static/logo-fmd-6aab6a081470907f7eda03013f74f686.svg";